<template>
    <div>
        <static-loading-indicator-icon :with-card="true" />

        <div v-if="!$store.getters.isExecutingRequest">
            <div class="card shadow-sm" v-if="!isSubscribed">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8">
                            <p
                                v-html="
                                    $t(
                                        'pages.admin.users.information.not_subscribed'
                                    )
                                "
                            ></p>
                        </div>
                        <div class="col-md-4 text-right">
                            <i
                                class="mdi mdi-48px text-danger mdi-account-remove"
                            ></i>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="card shadow-sm">
                    <div class="card-body">
                        <h4 class="card-title mb-3">
                            {{ $t("pages.subscription.title") }}
                        </h4>
                        <div class="row">
                            <div class="col-md-10">
                                <p
                                    v-html="
                                        $t(
                                            'pages.admin.users.information.subscribed'
                                        )
                                    "
                                    class="mb-0"
                                ></p>
                                <p>
                                    {{
                                        $t(
                                            "pages.admin.users.information.subscribed_duration"
                                        ) +
                                            $date(subscribedAt).format(
                                                "DD.MM.YYYY"
                                            )
                                    }}
                                </p>
                            </div>
                            <div class="col-md-2 text-center">
                                <i
                                    class="mdi mdi-96px mdi-check-decagram"
                                    :class="[
                                        onGracePeriod
                                            ? 'text-warning'
                                            : 'text-primary'
                                    ]"
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminUsersRepository from "../../../../repositories/Admin/AdminUsersRepository";
import LoadingIndicator from "../../../Includes/LoadingIndicator";
import PageHeader from "../../../Includes/PageHeader";
import StaticLoadingIndicatorIcon from "../../../Includes/StaticLoadingIndicatorIcon";

export default {
    name: "UserSubscription",
    components: { StaticLoadingIndicatorIcon, PageHeader, LoadingIndicator },
    data: () => ({
        isSubscribed: false,

        subscribedAt: null,
        onGracePeriod: false,
        endsAt: null,
        willBeRenewedAt: null,
        renewalPrice: "",
        monthsPaid: 0,

        invoices: []
    }),
    computed: {
        percentageOfMonthsForDowngrade() {
            return (this.monthsPaid / this.monthsRequiredForDowngrade) * 100;
        }
    },
    mounted() {
        this.getSubscriptionStatus();
    },
    methods: {
        getSubscriptionStatus() {
            AdminUsersRepository.getUserSubsciptionInfo(
                this.$route.params.user
            ).then(res => {
                this.isSubscribed = res.data.active;

                this.subscribedAt = res.data.subscribed_at;
                this.onGracePeriod = res.data.on_grace_period;
                this.endsAt = res.data.ends_at;
                this.willBeRenewedAt = res.data.will_be_renewed_at;
                this.renewalPrice = res.data.renewal_price;
                this.monthsPaid = res.data.months_paid;
            });
        }
    }
};
</script>

<style scoped></style>
